<template>
    <div class="container-fluid">
        <div class="text-center pb-5">
            <!-- <h1 class="h3">{{ employee.users.company.name }}</h1>
            <hr /> -->
            <div ref="digitalClock" class="digital-clock text-dark text-weight-400 h5">01:00 AM </div>

            <h4 class="text-dark pb-3 text-capitalize">{{Greetings}} {{userName}}</h4>
            <div>
                <h5>Continue to make a sale?</h5>
                <div v-if="companySettings.users_pin_login" class="btn-group">

                    <a class="btn btn-primary btn-lg text-light mt-lg-5" href="/makesale">Make a sale</a>
                    <a class="btn btn-outline-primary btn-lg mt-lg-5" v-b-modal="'change-user'">Switch Account</a>
                </div>
                <div v-else>
                    <a class="btn btn-primary btn-lg text-light mt-lg-5" href="/makesale">Make a sale</a>
                </div>

            </div>


        </div>
        <b-modal id="change-user" hide-footer>
            <div class="container">
                <div class="text-center">
                    <p>Not {{ userName }}? Switch account</p>

                </div>

                <form @submit.prevent="changeUser">
                    <div class="form-group">
                        <input v-model="switchUser.employee_code" type="text" class="form-control" placeholder="Employee code"/>
                    </div>
                    <div class="form-group">
                        <input v-model="switchUser.employee_pin" type="text" class="form-control" placeholder="PIN"/>
                        <p class="text-danger" v-if="switchUser.errorLoggingIn !=''">{{ switchUser.errorLoggingIn }}</p>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "MakeSale",

    data() {
        return {
            userName: '',
            userData: '',
            productCount: 1,
            employee: {},
            companySettings: {},
            switchUser: {
                employee_pin: '',
                employee_code: '',
                errorLoggingIn: ''
            },
            sideMenuWidth: 0,
            isSideMenuOpen: false,
            navItems: document.querySelectorAll(".mobile-bottom-nav__item"),
            activeNavItem: null,
        };
    },

    computed: {
        ...mapGetters(['userDetails']),
        Greetings() {
            const currentHour = parseInt(moment().format("HH"));
            if (currentHour >= 3 && currentHour < 12) return "Good Morning";
            if (currentHour >= 12 && currentHour < 15) return "Good Afternoon";
            if (currentHour >= 15 && currentHour < 20) return "Good Evening";
            return "Good Evening";
        }
    },

    watch: {
        userDetails: {
            immediate: true,
            handler(newVal) {
                if (newVal && typeof newVal === 'object') {
                    const fullName = newVal.full_name || newVal.name;
                    this.userName = fullName ? fullName.split(' ')[0] : ' ';
                } else {
                    this.userName = ' ';
                }
            }
        }
    },

    mounted() {
        this.clockUpdate();
        this.getCompanySettings();
        this.$store.dispatch('getUserDetails');
        this.clearLocalStorage();
        setInterval(this.clockUpdate, 1000);
    },

    methods: {
        clearLocalStorage() {
            if (this.userDetails && Object.keys(this.userDetails).length > 0) {
             this.$store.commit('resetStore')
            }
        },

        getCompanySettings() {
            axios.get('/api/settings')
                .then(results => {
                    this.companySettings = results.data;
                })
                .catch(errors => {
                    console.log(errors.message);
                });
        },

        changeUser() {
            this.switchUser.errorLoggingIn = '';
            axios.post('/api/change-user', { ...this.switchUser })
                .then(results => {
                    if (results.data.message) {
                        this.switchUser.errorLoggingIn = results.data.message;
                    } else {
                        window.location.reload();
                    }
                })
                .catch(errors => {
                    console.log(errors.message);
                });
        },

        clockUpdate() {
            if (this.$refs.digitalClock) {
                this.$refs.digitalClock.textContent = moment().format('h:mm a');
            }
        },

        openSideMenu() {
            this.sideMenuWidth = 250;
            this.$refs.app.style.marginLeft = '250px';
        },

        selectNavItem(item) {
            this.navItems.forEach(navItem => {
                navItem.classList.remove("mobile-bottom-nav__item--active");
            });
            this.activeNavItem = item;
            this.activeNavItem.classList.add("mobile-bottom-nav__item--active");
        },
    }
}
</script>


<style scoped>

</style>
